import Vue from 'vue'
import App from './App.vue'
import router from './router'
import directive from './directive' // directive
import auth from '@/plugins/auth'
//element 样式
import 'element-ui/lib/theme-chalk/index.css'
//openLayer 样式
import 'ol/ol.css'
import '@/styles/map.css'
//ol地图组件引用
import '@/components/OlMap/index'
//cesium地图组件引用
import '@/components/CesiumMap/index'
//图标组件引用
import '@/icons/index'
// 引入右键菜单组件
import Contextmenu from "vue-contextmenujs"
Vue.use(Contextmenu);

import ElementUI from 'element-ui'

Vue.prototype.$auth = auth

Vue.use(ElementUI)
Vue.use(directive)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
